<template>
	<div class="pui-form">

		<v-form class="mb-4 pb-4" ref="form" v-model="valid" lazy-validation @submit.prevent v-if="modelLoaded">
			<v-layout wrap class="pui-form-layout">
				<v-flex xs12 md12>
					<pui-field-set highlighted>
						<v-layout wrap>
							<!-- IDRESCATEGORIA -->
							<v-flex xs12 md1>
								<pui-text-field
									:id="`idrescategoria-mrescategoriacondicion`"
									:label="$t('mrescategoriacondicion.idrescategoria')"
									v-model="model.idrescategoria"
									disabled
									toplabel
									maxlength="10"
								>
								</pui-text-field>
							</v-flex>
							<!-- NAME -->
							<v-flex xs12 md4>
								<pui-text-field
									:id="`name-mrescategoriacondicion`"
									v-model="model.name"
									:label="$t('mrescategoriacondicion.name')"
									:disabled="formDisabled"
									required
									toplabel
									maxlength="30"
								></pui-text-field>
							</v-flex>
							<!-- FECBAJA -->
							<v-flex xs12 md2>
								<pui-date-field
								:id="`fecbaja-mrescategoriacondicion`"
								:label="$t(`mrescategoriacondicion.fecbaja`)"
								v-model="model.fecbaja"
								toplabel
								></pui-date-field>
							</v-flex>
							<!-- MINI AUDIT -->
							<pui-form-mini-audit class="pl-2" :model="model" v-if="!isCreatingElement"></pui-form-mini-audit>
						</v-layout>
					</pui-field-set>
				</v-flex>
			</v-layout>

			<!-- Page Footer -->
			<pui-form-footer v-if="!isModalDialog">
				<pui-form-footer-btns
					:formDisabled="formDisabled"
					:saveDisabled="saving"
					:saveAndNew="saveAndNew"
					:saveAndUpdate="saveAndUpdate"
					:save="save"
					:back="back"
				></pui-form-footer-btns>
			</pui-form-footer>
		</v-form>
		<pui-form-loading v-else></pui-form-loading>
	</div>
</template>

<script>
import {PuiFormMethodsMixin} from '@Pui9Components';

export default {
	name: 'mres-categoria-condicion-form',
	mixins: [PuiFormMethodsMixin],
	data() {
		return {
			modelName: 'mrescategoriacondicion',
			refreshSelect: 0
		};
	},
	methods: {
		afterGetData() {
			// Do something after get data from server
			this.setParentPk();

			if (!this.model.articulo15) {
				this.model.articulo15 = 0;
			}
		},
		setParentPk() {
			const parentModel = this.$puiUtils.getPathModelMethodPk(this.$router, this.parentModelName);
			if (parentModel) {
				//this.model.[LOCAL_FK_ATTRIBUTE] = parentModel.pk.[REMOTE_FK_ATTRIBUTE];
			}
		},
		allCategoriaestiba(model) {
			if (!this.$appUtils.isEmpty(model.allcategoriasestiba)) return model.allcategoriasestiba;

			const params = {};

			const url = this.$store.getters.getModelByName(this.modelName).url.getCategoriasEstiba;
			var title = this.$puiI18n.t('puiaction.notifyTitle') + ' > ' + this.$puiI18n.t('mimdg.getCategoriasEstiba.title');
			this.$puiRequests.getRequest(
				url,
				params,
				response => {
					// Valid response, do code and close modal
					model.allcategoriasestiba = response.data.allcategoriasestiba;
					this.refreshSelect++;
				},
				e => {
					// Error response, do code and not close modal
					let message = this.$puiI18n.t('puiaction.notifyError');
					if (e.response && e.response.data) {
						message = e.response.data.message;
					}
					this.$puiNotify.error(message, title);
				}
			);
		}
	},
	computed: {
		getTitleDatos() {
			return this.$t('form.mrescategoriacondicion');
		}
	},
	created() {}
};
</script>
